module.exports = __webpack_public_path__ + "img/根子柏桥贡园1.2944c3ee.png";